import { promisify } from 'util'

const validator = async (schema, data, setErrors) => {
  const errors = await promisify(schema.validate.bind(schema))(data)

  if (Object.keys(errors).length > 0) {
    setErrors(errors)
    return errors
  }
}

export default validator
